export default "__VITE_ASSET__$h5G7UWr__"